import React from 'react';

const Button = ({children,disabled}) => {
    return (
        <button disabled={disabled} className="bg-blue text-white px-8 py-4 rounded-full shadow-xl">
            {children}
        </button>
    );
}

export default Button;
